import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import {
  AILAB_PERMISSIONS,
  LEGACY_AGENT_ONLY_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { frontendURL } from '../../../helper/URLHelper';
const AilabWrapper = () => import('./AilabWrapper.vue');
const AssistantIndex = () => import('./assistants/Index.vue');
const AssistantEdit = () => import('./assistants/Edit.vue');
// import AssistantSettings from './assistants/settings/Settings.vue';
const AssistantInboxesIndex = () => import('./assistants/inboxes/Index.vue');
const AssistantGuardrailsIndex = () =>
  import('./assistants/guardrails/Index.vue');
const AssistantGuidelinesIndex = () =>
  import('./assistants/guidelines/Index.vue');
const AssistantScenariosIndex = () =>
  import('./assistants/scenarios/Index.vue');
const DocumentsIndex = () => import('./documents/Index.vue');
const ResponsesIndex = () => import('./responses/Index.vue');
const ProductInfoIndex = () => import('./productInfo/Index.vue');
const AssistantV2Index = () => import('./assistantV2/Index.vue');
const AICloserIndex = () => import('./aiCloser/Index.vue');
const AIGamerIndex = () => import('./aiGamer/Index.vue');
const AIStudioIndex = () => import('./aiStudio/Index.vue');
const AIStudioManage = () => import('./aiStudio/Manage.vue');
const AIStudioInsights = () => import('./aiStudio/pages/Insights.vue');
const AIStudioDashboard = () => import('./aiStudio/pages/Dashboard.vue');
const BrandTrainingDashboard = () => import('./brandTraining/Dashboard.vue');
const BrandTrainingAssistant = () =>
  import('./brandTraining/AssistantSettings.vue');
const BrandTrainingKnowledge = () =>
  import('./brandTraining/KnowledgeManager.vue');
const ailabRoutePermissions = {
  anyOf: ['administrator', LEGACY_AGENT_ONLY_PERMISSIONS, AILAB_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ailab/assistants'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_assistants_index', component: AssistantIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/assistants/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_assistants_edit', component: AssistantEdit },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/inboxes'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_inboxes_index',
        component: AssistantInboxesIndex,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/guardrails'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_guardrails_index',
        component: AssistantGuardrailsIndex,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/scenarios'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_scenarios_index',
        component: AssistantScenariosIndex,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/guidelines'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_guidelines_index',
        component: AssistantGuidelinesIndex,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/documents'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_documents_index', component: DocumentsIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/responses'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_responses_index', component: ResponsesIndex },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/product-info'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_product_info', component: ProductInfoIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/assistants/:assistantId/v2'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_assistant_v2', component: AssistantV2Index },
    ],
  },
  // Aliases for Assistant V2 so the left sidebar can highlight AI Closer/AI gamer correctly.
  {
    path: frontendURL('accounts/:accountId/ailab/ai-closer/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_ai_closer_assistant_v2',
        component: AssistantV2Index,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/ai-gamer/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_ai_gamer_assistant_v2',
        component: AssistantV2Index,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/ai-closer'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_ai_closer_index', component: AICloserIndex },
    ],
  },
  // AI Studio (new) — modern SMB-friendly entry point. Backend / DB / runtime
  // are shared with AI Closer; AI Studio just gives non-technical owners a
  // simpler workflow (Knowledge → Live test → Channels). Assistants created
  // here are tagged wlab_sidebar_key: 'ai_studio' so they show up only here.
  {
    path: frontendURL('accounts/:accountId/ailab/ai-studio'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_ai_studio_index', component: AIStudioIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/ai-studio/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_ai_studio_manage', component: AIStudioManage },
      {
        path: 'insights',
        name: 'ailab_ai_studio_insights',
        component: AIStudioInsights,
      },
      {
        path: 'dashboard',
        name: 'ailab_ai_studio_dashboard',
        component: AIStudioDashboard,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/ai-gamer'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_ai_gamer_index', component: AIGamerIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/brand-training'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_brand_training_dashboard',
        component: BrandTrainingDashboard,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/brand-training/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_brand_training_assistant',
        component: BrandTrainingAssistant,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/brand-training/:assistantId/knowledge'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_brand_training_knowledge',
        component: BrandTrainingKnowledge,
      },
    ],
  },
];
